"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getGlobalConfig = getGlobalConfig;
var _objectHelpers = require("./objectHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Get Global Config
 *
 * @returns {object} - The global config object attached to the window
 */
function getGlobalConfig() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    return (0, _objectHelpers.deepClone)(window.config);
  }
  return undefined;
}
var _default = exports["default"] = {
  getGlobalConfig: getGlobalConfig
};